/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/member-ordering */
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import {
  ColDef,
  ColumnMovedEvent,
  ColumnResizedEvent,
  ColumnState,
  ColumnVisibleEvent,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
  RowClassParams,
  RowClickedEvent,
  SortChangedEvent,
  SuppressKeyboardEventParams,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
import { CurrencyPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { getAllFocusableElementsOf, getEventPath } from '@ellf/app-common';
import { SelectItem } from '@ellf/common-interfaces';
import { merge } from 'lodash';
import moment from 'moment';
import { DataGridAction } from './data-grid-action';
import { DataGridActionParamsDataInterface } from './data-grid-action-params-data-interface';
import { DataGridActionRenderer } from './data-grid-action-renderer.component';

@Component({
  selector: 'ellf-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrencyPipe],
  standalone: false,
})
export class DataGridComponent implements OnInit {
  @Input()
  canEdit? = false;

  @Input()
  editVisible?: (entity: any) => boolean;

  @Input()
  deleteVisible?: (entity: any) => boolean;
  // ;

  @Input()
  viewVisible?: (entity: any) => boolean;

  @Input()
  canDelete? = false;

  @Input()
  canView? = false;

  @Input()
  gridOptions?: GridOptions;

  @Input()
  hideCommands = false;

  @Input()
  rowSelection?: 'single' | 'multiple';

  // private _selectedRow = undefined;
  // get selectedRow() {
  //   return this._selectedRow;
  // }
  // @Input()
  // set selectedRow(value: any) {
  //   this._selectedRow = value;

  //   this.gridApi?.getRowNode(value.id)?.setSelected(true);
  // }

  private _canSelect = false;
  get canSelect() {
    return this._canSelect;
  }
  @Input()
  set canSelect(value: boolean) {
    this._canSelect = value;
    this.rowSelection = value ? 'multiple' : 'single';
  }

  private _selectedItems: any[] = [];
  get selectedItems() {
    return this._selectedItems;
  }
  @Input()
  set selectedItems(values: any[]) {
    this._selectedItems = values;
    this.setSelectedItems();
  }

  internalGridOptions!: GridOptions;

  private _columnDefs?: ColDef[];
  get columnDefs(): ColDef[] | undefined {
    return this._columnDefs;
  }
  @Input() set columnDefs(value: ColDef[] | undefined) {
    this._columnDefs = value ? merge([], value) : undefined;
    this.setGridColumnDefs();
  }

  // @Input()
  // items: any[] = [];
  private _items: any[] = [];
  get items() {
    return this._items;
  }
  @Input()
  set items(values: any[]) {
    this._items = values;
    this.setSelectedItems();
  }

  @Input()
  customActions: DataGridAction[] = [];

  get actions(): DataGridAction[] {
    return this.getActions();
  }

  @Output()
  add: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  download: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  edit = new EventEmitter<any>();

  @Output()
  view = new EventEmitter<any>();

  @Output()
  delete = new EventEmitter<any>();

  @Output()
  selected = new EventEmitter<any[]>();

  @Output()
  columnStateChanged = new EventEmitter<ColumnState[]>();

  @Output()
  rowClicked = new EventEmitter<any>();

  modules = [
    ClientSideRowModelModule,
    ColumnsToolPanelModule,
    ServerSideRowModelModule,
    SideBarModule,
  ];

  gridApi?: GridApi;

  constructor(
    private currencyPipe: CurrencyPipe,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const commonGridOptions: GridOptions = {
      rowHeight: 30,
      suppressCellFocus: true,
      rowSelection: this.rowSelection,
      sideBar: {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Colonne',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressPivotMode: true,
              suppressRowGroups: true,
              suppressValues: true,
            },
          },
        ],
        // defaultToolPanel: 'columns',
      },
      onGridReady: (e: GridReadyEvent) => this.onGridReady(e),
      onSortChanged: (e: SortChangedEvent) => this.onColumnStateChanged(e),
      onColumnVisible: (e: ColumnVisibleEvent) => this.onColumnStateChanged(e),
      onColumnMoved: (e: ColumnMovedEvent) => this.onColumnStateChanged(e),
      onColumnResized: (e: ColumnResizedEvent) => this.onColumnStateChanged(e),
      defaultColDef: {
        editable: false,
        enablePivot: false,
        enableValue: false,
        sortable: true,
        resizable: true,
        flex: 1,
        // minWidth: 200,
        suppressMenu: true,
      },
      components: {
        gridComponentBooleanRenderer: this.gridComponentBooleanRenderer,
        gridComponentEnumRenderer: this.gridComponentEnumRenderer,
        customGridActionRenderer: DataGridActionRenderer,
      },
      columnTypes: {
        boolColumn: {
          cellRenderer: 'gridComponentBooleanRenderer',
        },
        numberColumn: {
          filter: 'agNumberColumnFilter',
        },
        currencyColumn: {
          filter: 'agNumberColumnFilter',
          valueFormatter: (params: ValueFormatterParams) => {
            if (params.value == null) {
              return '';
            }
            return (
              '€ ' + this.currencyPipe.transform(params.value + '', ' ') || ''
            );
          },
        },
        enumColumn: {
          cellRenderer: 'gridComponentEnumRenderer',
        },
        dateColumn: {
          // filter: 'agDateColumnFilter',
          valueFormatter: (params: ValueFormatterParams) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('L');
          },
          valueGetter: (params: ValueGetterParams) => {
            const field = params.colDef.field as string;
            const data = field
              .split('.')
              .reduce((p, c) => (p && p[c]) || null, params.data);
            if (data) {
              return new Date(data);
            } else {
              return null;
            }
          },
          tooltipValueGetter: (params) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('L');
          },
        },
        datetimeColumn: {
          filter: 'agDateColumnFilter',
          valueFormatter: (params: ValueFormatterParams) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('DD/MM/YYYY HH:mm');
          },
          valueGetter: (params: ValueGetterParams) => {
            const field = params.colDef.field as string;
            const data = field
              .split('.')
              .reduce((p, c) => (p && p[c]) || null, params.data);
            if (data) {
              return moment(data).toDate();
            } else {
              return null;
            }
          },
          tooltipValueGetter: (params) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('LLL');
          },
        },
        actionColumn: {
          cellRenderer: 'customGridActionRenderer',
        },
      },
      getRowStyle: /*this.rowSelection
        ? undefined
        :*/ (params: RowClassParams) => {
        if (params.data && params.data.isValid === false) {
          return { background: '#FFE5F2' };
        }
        if (params.node.rowIndex) {
          if (params.node.rowIndex % 2 === 0) {
            return { background: '#ffffff' };
          }
          return { background: '#fcfcfc' };
        }
        return { background: '#ffffff' };
      },
      getRowId: (param) => param.data.id,
    };

    if (this.gridOptions) {
      this.internalGridOptions = merge(commonGridOptions, {
        ...this.gridOptions,
        onGridReady: (e: GridReadyEvent) => {
          this.onGridReady(e);
          if (this.gridOptions?.onGridReady) {
            this.gridOptions.onGridReady(e);
          }
        },
      });
    } else {
      this.internalGridOptions = commonGridOptions;
    }
  }

  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    //console.log('onGridReady');
    if (this.actions.length > 0) {
      this.gridApi.autoSizeColumns(['actions']);
    }
    this.setSelectedItems();
  }

  gridComponentBooleanRenderer(params: ICellRendererParams) {
    const value = params.value;
    let template = `<div class="d-flex align-items-center h-100">`;
    if (value) {
      template += `Sì`;
      // <i class="material-icons" data-action-type="check">check</i>
    } else {
      template += `No`;
      // template += `<i class="material-icons" data-action-type="close">close</i>`;
    }
    return template + '</div>';
  }

  gridComponentEnumRenderer(
    params: ICellRendererParams & { elementValues: SelectItem[] },
  ) {
    const value = params.value;

    let template = `<div class="d-flex align-items-center h-100">`;
    if (value != null) {
      if (
        params.elementValues != undefined &&
        params.elementValues.length > 0
      ) {
        template += params.elementValues.find(
          (e) => e.value === value,
        )?.description;
      } else {
        template += value;
      }
      // <i class="material-icons" data-action-type="check">check</i>
    }
    return template + '</div>';
  }

  protected getActions() {
    const actions: DataGridAction[] = [];

    actions.push({
      description: 'modifica',
      class: 'icon-edit-2',
      //class: 'mdi mdi-pencil',
      onAction: (entity: any) => {
        this.edit.emit(entity);
      },
      visible: (entity: DataGridActionParamsDataInterface) =>
        this.editVisible
          ? !!this.canEdit && this.editVisible(entity)
          : !!this.canEdit && !(entity.locked || false),
    });
    if (!this.customActions.find((ca) => ca.class === 'icon-eye')) {
      actions.push({
        description: 'visualizza',
        class: 'icon-eye',
        //class: 'mdi mdi-pencil',
        onAction: (entity: any) => {
          this.view.emit(entity);
        },
        visible: (entity: DataGridActionParamsDataInterface) =>
          this.viewVisible
            ? !!this.canView && this.viewVisible(entity)
            : !!this.canView && !(this.canEdit && !(entity.locked || false)),
      });
    }
    actions.push({
      description: 'elimina',
      class: 'icon-trash red',
      onAction: (entity: any) => {
        this.delete.emit(entity);
      },
      visible: (entity: DataGridActionParamsDataInterface) =>
        this.deleteVisible
          ? !!this.canDelete && this.deleteVisible(entity)
          : !!this.canDelete &&
            !entity.siaExternalId &&
            !(entity.locked || false),
    });

    return [...actions, ...this.customActions];
  }

  onSelectionChanged(event: any) {
    //SelectionChangedEvent
    const selectedRow = this.gridApi?.getSelectedNodes() || [];
    if (this.selected) {
      this.selected.emit(selectedRow.map((r) => r.data));
    }
  }

  setSelectedItems() {
    this.gridApi?.forEachNode((rn) => {
      const selected = !!this._selectedItems.find((v) => v.id === rn.data.id);
      rn.setSelected(selected);
    });
  }

  rowDataChanged() {
    this.setSelectedItems();
  }

  onColumnStateChanged(
    e:
      | SortChangedEvent
      | ColumnVisibleEvent
      | ColumnMovedEvent
      | ColumnResizedEvent,
  ) {
    this.columnStateChanged.emit(e.api.getColumnState());
  }

  rowClickedChanged(event: RowClickedEvent) {
    if (this.rowClicked) {
      this.rowClicked.emit(event.data);
    }
  }

  setGridColumnDefs() {
    if (this._columnDefs) {
      if (this.canSelect) {
        if (!this._columnDefs.find((c) => c.colId === 'selection')) {
          this.columnDefs?.splice(0, 0, {
            colId: 'selection',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            pinned: 'left',
            width: 30,
            filter: false,
            sortable: false,
            resizable: false,
            minWidth: 0,
            suppressMovable: true,
            suppressColumnsToolPanel: true,
            flex: 0,
          });
        }
      }
      if (!this.hideCommands) {
        const actionsIndex = this._columnDefs.findIndex(
          (c) => c.colId === 'actions',
        );
        if (actionsIndex >= 0) this._columnDefs.splice(actionsIndex, 1);
        this._columnDefs.push({
          colId: 'actions',
          pinned: 'right',
          width: 10,
          type: 'actionColumn',
          cellRendererParams: {
            context: this,
          },
          filter: false,
          sortable: false,
          resizable: false,
          minWidth: 0,
          suppressMovable: true,
          suppressColumnsToolPanel: true,
          flex: 0,
          suppressSizeToFit: true,
          suppressKeyboardEvent: ({
            event,
            api,
          }: SuppressKeyboardEventParams<any>) => {
            const { key, shiftKey } = event;
            const path = getEventPath(event);
            const isTabForward = key === 'Tab' && shiftKey === false;
            const isTabBackward = key === 'Tab' && shiftKey === true;
            let suppressEvent = false;
            // Handle cell children tabbing
            if (isTabForward || isTabBackward) {
              const eGridCell = path.find((el) => {
                if (el.classList === undefined) return false;
                return el.classList.contains('ag-cell');
              });
              if (!eGridCell) {
                return suppressEvent;
              }
              const focusableChildrenElements =
                getAllFocusableElementsOf(eGridCell);
              const lastCellChildEl =
                focusableChildrenElements[focusableChildrenElements.length - 1];
              const firstCellChildEl = focusableChildrenElements[0];
              // Suppress keyboard event if tabbing forward within the cell and the current focused element is not the last child
              if (isTabForward && focusableChildrenElements.length > 0) {
                const isLastChildFocused =
                  lastCellChildEl && document.activeElement === lastCellChildEl;
                if (!isLastChildFocused) {
                  suppressEvent = true;
                }
              }
              // Suppress keyboard event if tabbing backwards within the cell, and the current focused element is not the first child
              else if (isTabBackward && focusableChildrenElements.length > 0) {
                const cellHasFocusedChildren =
                  eGridCell.contains(document.activeElement) &&
                  eGridCell !== document.activeElement;
                // Manually set focus to the last child element if cell doesn't have focused children
                if (!cellHasFocusedChildren) {
                  lastCellChildEl.focus();
                  // Cancel keyboard press, so that it doesn't focus on the last child and then pass through the keyboard press to
                  // move to the 2nd last child element
                  event.preventDefault();
                }
                const isFirstChildFocused =
                  firstCellChildEl &&
                  document.activeElement === firstCellChildEl;
                if (!isFirstChildFocused) {
                  suppressEvent = true;
                }
              }
            }
            return suppressEvent;
          },
        } as ColDef);
      } else {
        this._columnDefs =
          this.columnDefs?.filter((c) => c.colId !== 'actions') || [];
      }
      this.gridApi?.setGridOption('columnDefs', this._columnDefs);
    }
  }
}
